/**
 * Utilities for handling the monthlyHours format migration.
 *
 * Legacy format: number[]  — positional array (index 0 = project start month)
 * New format:    Record<string, number> — keyed by "YYYY-MM"
 *
 * The DB column (NVARCHAR(MAX)) stores JSON; both formats coexist during
 * the progressive migration.  Use `normaliseMonthlyHours` on every read
 * to guarantee the keyed format.
 */

export function isLegacyMonthlyHours(value: unknown): value is number[] {
  return Array.isArray(value);
}

export function convertLegacyMonthlyHours(
  arr: number[],
  projectStartDate: string,
): Record<string, number> {
  const result: Record<string, number> = {};
  const start = new Date(projectStartDate);
  for (let i = 0; i < arr.length; i++) {
    const d = new Date(start.getFullYear(), start.getMonth() + i, 1);
    const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
    result[key] = arr[i];
  }
  return result;
}

export function normaliseMonthlyHours(
  value: number[] | Record<string, number> | undefined | null,
  projectStartDate: string,
): Record<string, number> {
  if (!value) return {};
  if (isLegacyMonthlyHours(value)) return convertLegacyMonthlyHours(value, projectStartDate);
  return value;
}

export function getSortedMonthKeys(monthlyHours: Record<string, number>): string[] {
  return Object.keys(monthlyHours).sort();
}
